function fetchConfig(type = "json") {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Accept: `application/${type}`,
        },
    };
}

if (!customElements.get("product-form")) {
    customElements.define(
        "product-form",
        class ProductForm extends HTMLElement {
            constructor() {
                super();

                this.form = this.querySelector("form");
                this.form.querySelector("[name=id]").disabled = false;
                this.form.addEventListener(
                    "submit",
                    this.onSubmitHandler.bind(this)
                );
                this.cartNotification =
                    document.querySelector("cart-notification");
            }

            onSubmitHandler(evt) {
                evt.preventDefault();
                const submitButton = this.querySelector('[type="submit"]');
                if (submitButton.classList.contains("loading")) return;

                this.handleErrorMessage();
                this.cartNotification.setActiveElement(document.activeElement);

                submitButton.setAttribute("aria-disabled", true);
                submitButton.classList.add("loading");
                this.querySelector(
                    ".loading-overlay__spinner"
                ).classList.remove("hidden");

                const config = fetchConfig("javascript");
                config.headers["X-Requested-With"] = "XMLHttpRequest";
                delete config.headers["Content-Type"];

                const formData = new FormData(this.form);
                formData.append(
                    "sections",
                    this.cartNotification
                        .getSectionsToRender()
                        .map((section) => section.id)
                );
                formData.append("sections_url", window.location.pathname);
                config.body = formData;

                fetch(`${routes.cart_add_url}`, config)
                    .then((response) => response.json())
                    .then((response) => {
                        if (response.status) {
                            this.handleErrorMessage(response.description);
                            return;
                        }

                        this.cartNotification.renderContents(response);
                    })
                    .catch((e) => {
                        console.error(e);
                    })
                    .finally(() => {
                        submitButton.classList.remove("loading");
                        submitButton.removeAttribute("aria-disabled");
                        this.querySelector(
                            ".loading-overlay__spinner"
                        ).classList.add("hidden");
                    });
            }

            handleErrorMessage(errorMessage = false) {
                this.errorMessageWrapper =
                    this.errorMessageWrapper ||
                    this.querySelector(".product-form__error-message-wrapper");
                this.errorMessage =
                    this.errorMessage ||
                    this.errorMessageWrapper.querySelector(
                        ".product-form__error-message"
                    );

                this.errorMessageWrapper.toggleAttribute(
                    "hidden",
                    !errorMessage
                );

                if (errorMessage) {
                    this.errorMessage.textContent = errorMessage;
                }
            }
        }
    );
}

// Original quantity-input web component
customElements.define('quantity-input', class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    
    this.querySelectorAll('button').forEach(
      button => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const variantJson = window.Product?.variants;

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const value = parseInt(cents || 0);
    const dollars = Math.floor(value / 100);
    const cents_part = (value % 100).toString().padStart(2, '0');
    return `$${dollars}.${cents_part}`;
  }

  function updatePrice(variantId) {
    if (!variantJson) return;
    
    const selectedVariant = variantJson.find(v => v.id == variantId);
    if (!selectedVariant) return;

    const priceBlock = document.querySelector('.price__regular .price-item--regular');
    if (priceBlock) {
      priceBlock.innerHTML = `
        <span class="current-price">
          ${formatMoney(selectedVariant.price)}
        </span>
        ${selectedVariant.compare_at_price > selectedVariant.price ? `
          <span class="compare-price" style="text-decoration:line-through;">
            ${formatMoney(selectedVariant.compare_at_price)}
          </span>
        ` : ''}
      `;
    }
  }

  function handleVariantChange(event) {
    let variantId;

    // For dropdown
    if (event.target.tagName === 'SELECT') {
      const selectedOption = event.target.options[event.target.selectedIndex];
      variantId = selectedOption.dataset.variantId;
    }

    // For radio buttons
    if (event.target.tagName === 'INPUT' && event.target.type === 'radio') {
      variantId = event.target.dataset.variantId;
    }

    if (variantId) {
      updatePrice(variantId);
    }
  }

  // Global event listener for variant changes
  document.body.addEventListener('change', function(event) {
    if (event.target.matches("variant-selects select, variant-radios input[type='radio']")) {
      handleVariantChange(event);
    }
  });

  // Initial price update
  window.addEventListener('load', () => {
    const selectedOption = document.querySelector('select[name^="options"] option[selected], input[name^="options"]:checked');
    if (selectedOption) {
      handleVariantChange({ target: selectedOption });
    }
  });
});

// Image switching for variants
// ... existing code ...

document.addEventListener("DOMContentLoaded", function () {
    console.log("📸 Image switcher loaded...");

    const variantToImageMap = {
        "46091143971031": "34956167971031", // Screw-In
        "46091144003799": "34956170100951", // Click-In
    };

    console.log("Variant to Image Map:", variantToImageMap);

    function showVariantImage(variantId) {
        console.log(`🎯 Switching to variant ID: ${variantId}`);

        const imageId = variantToImageMap[variantId];
        if (!imageId) {
            console.warn(`⚠️ No image mapping found for Variant ID: ${variantId}`);
            return;
        }

        const productContainer = document.querySelector("#Slider-Gallery-template--16826634109143__main");
        if (!productContainer) {
            console.warn("⚠️ Product container not found.");
            return;
        }

        const allImages = productContainer.querySelectorAll(".variant-image");
        console.log("🔍 Found Images:", allImages.length, allImages);

        // Hide all images first
        allImages.forEach(image => {
            image.style.display = 'none';
        });

        // Show only the selected variant image
        const selectedImage = productContainer.querySelector(`.variant-image[data-media-id="template--16826634109143__main-${imageId}"]`);
        
        if (selectedImage) {
            selectedImage.style.display = 'block';
            console.log(`✅ Image found and displayed for Image ID: ${imageId}`);
        } else {
            console.warn(`⚠️ No image found for Image ID: ${imageId}`);
        }
    }

    document.body.addEventListener('change', function(event) {
        if (event.target.matches("input[type='radio'][name='options[Connection Type]']")) {
            const variantId = event.target.dataset.variantId;
            console.log("Variant Changed:", variantId);
            if (variantId) showVariantImage(variantId);
        }
    });

    // Show default variant image on page load
    const selectedOption = document.querySelector("input[type='radio'][name='options[Connection Type]']:checked");
    if (selectedOption) {
        showVariantImage(selectedOption.dataset.variantId);
    } else {
        showVariantImage("46091143971031"); // Default to the specified variant
    }
});

// ... existing code ...